import { Button, XIcon } from '@tovala/component-library'
import { Dialog, DialogPanel } from '@headlessui/react'
import { ReactNode } from 'react'

const DetailsDialog = ({
  children,
  onClose,
}: {
  children: ReactNode
  onClose(): void
}) => {
  return (
    <Dialog onClose={onClose} open={true}>
      <div
        className="fixed inset-0 z-30 bg-black opacity-40"
        onClick={onClose}
      />
      <div className="fixed inset-0 z-30 flex justify-end">
        <DialogPanel className="flex h-full w-full max-w-[513px] flex-col bg-grey-0">
          <div className="flex justify-end border-b border-grey-3 px-4 py-5">
            <Button
              aria-label="Close"
              buttonStyle="link"
              onClick={onClose}
              size="auto"
            >
              <div className="h-6 w-6">
                <XIcon />
              </div>
            </Button>
          </div>

          {children}
        </DialogPanel>
      </div>
    </Dialog>
  )
}

export default DetailsDialog
